/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({ organizationId: ZodTypes.Id });

export const PostOrganizationUser = {
  id: 'organization-user.post',
  tag: 'Organization',
  summary: 'Invite user to organization',
  description: 'Invite a user to the organization. Only the owner may invite users.',
  method: 'post',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) => `/organization/${params.organizationId}/user`,
  request: {
    params: Params,
    body: {
      content: {
        'application/json': {
          schema: z.strictObject({
            email: z.string().email(),
          }),
        },
      },
    },
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.string().optional(),
        },
      },
    },
  },
} as const satisfies Endpoint;
